export const actionTypes: any = {
  GET_FD_TENURE_START: 'GET_FD_TENURE_START',
  GET_FD_TENURE_SUCCESS: 'GET_FD_TENURE_SUCCESS',
  GET_FD_TENURE_FINISH: 'GET_FD_TENURE_FINISH',

  ADD_FD_TENURE_START: 'ADD_FD_TENURE_START',
  ADD_FD_TENURE_SUCCESS: 'ADD_FD_TENURE_SUCCESS',
  ADD_FD_TENURE_FINISH: 'ADD_FD_TENURE_FINISH',
  ADD_FD_TENURE_RESET: 'ADD_FD_TENURE_RESET',

  UPDATE_FD_TENURE_START: 'UPDATE_FD_TENURE_START',
  UPDATE_FD_TENURE_SUCCESS: 'UPDATE_FD_TENURE_SUCCESS',
  UPDATE_FD_TENURE_FINISH: 'UPDATE_FD_TENURE_FINISH',
  UPDATE_FD_TENURE_RESET: 'UPDATE_FD_TENURE_RESET',

  DELETE_FD_TENURE_START: 'DELETE_FD_TENURE_START',
  DELETE_FD_TENURE_SUCCESS: 'DELETE_FD_TENURE_SUCCESS',
  DELETE_FD_TENURE_FINISH: 'DELETE_FD_TENURE_FINISH',

  SINGLE_ACTIVATE_FD_TENURE_REQUEST: 'SINGLE_ACTIVATE_FD_TENURE_REQUEST',
  SINGLE_ACTIVATE_FD_TENURE_SUCCESS: 'SINGLE_ACTIVATE_FD_TENURE_SUCCESS',
  SINGLE_ACTIVATE_FD_TENURE_FINISH: 'SINGLE_ACTIVATE_FD_TENURE_FINISH',

  SINGLE_DEACTIVATE_FD_TENURE_REQUEST: 'SINGLE_DEACTIVATE_FD_TENURE_REQUEST',
  SINGLE_DEACTIVATE_FD_TENURE_SUCCESS: 'SINGLE_DEACTIVATE_FD_TENURE_SUCCESS',
  SINGLE_DEACTIVATE_FD_TENURE_FINISH: 'SINGLE_DEACTIVATE_FD_TENURE_FINISH',
}
